import {
    buildUrlWithQueryParameters,
    extractPathFromHash,
    getQueryParamsFromHref,
    getQueryParams,
    isValidURL,
    objectToQueryString,
    removeLeadingHashtagFromNavigationHashIfNeeded,
    updateQueryParams,
} from '@famly/vet_ts-utils_url';

export {
    /**
     * @deprecated import from '@famly/vet_ts-utils_url' instead
     */
    buildUrlWithQueryParameters,
    /**
     * @deprecated import from '@famly/vet_ts-utils_url' instead
     */
    extractPathFromHash,
    /**
     * @deprecated import from '@famly/vet_ts-utils_url' instead
     */
    getQueryParamsFromHref,
    /**
     * @deprecated import from '@famly/vet_ts-utils_url' instead
     */
    getQueryParams,
    /**
     * @deprecated import from '@famly/vet_ts-utils_url' instead
     */
    isValidURL,
    /**
     * @deprecated import from '@famly/vet_ts-utils_url' instead
     */
    objectToQueryString,
    /**
     * @deprecated import from '@famly/vet_ts-utils_url' instead
     */
    removeLeadingHashtagFromNavigationHashIfNeeded,
    /**
     * @deprecated import from '@famly/vet_ts-utils_url' instead
     */
    updateQueryParams,
};

export const isBadNetworkError = (error: Error) => {
    // "TypeError: Failed to fetch" means there is a connectivity issue between the client and the service
    return error instanceof TypeError && error.message === 'Failed to fetch';
};
